import { useEffect, useMemo, useState } from "react";
import { DEFAULT_PAGE_SIZE } from "../lib/pagination";

export function usePagination(items, initialPageSize = DEFAULT_PAGE_SIZE) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSizeState] = useState(initialPageSize);
  const total = items.length;

  useEffect(() => {
    setPage(1);
  }, [total]);

  const pageItems = useMemo(
    () => items.slice((page - 1) * pageSize, page * pageSize),
    [items, page, pageSize]
  );

  const setPageSize = (size) => {
    setPageSizeState(size);
    setPage(1);
  };

  const goToPage = (p) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setPage(p);
  };

  return { page, pageSize, total, pageItems, setPage: goToPage, setPageSize };
}
